export default ({ params }) => ({
  ...params,
  id: Number.isNaN(Number(params.id)) ? null : Number(params.id),
  isNew: params.id && params.id === 'new',
});
